export default __webpack_public_path__ + "static/media/gallery-wip-handle_05.e9139b6a.jpg";